// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"ccbdcc0b","629":"2e94f033","747":"0fef0d37"}[chunkId] + ".chunk.js";
};